import axiosInstance from "../axios/axiosInstance";

export const fetcher = async (url: string, config?: any) => {
  try {
    const response = await axiosInstance.get(url, config ?? {});
    return response.data;
  } catch (error) {
    throw error;
  }
};
